
export const environment = {
  production: false,
  appVersion: '2.9.2'
};
